import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '';

  // Handle scroll to toggle navbar background
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    // Cleanup listener on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Divisions', path: '/divisions' },
    { name: 'Investor Relations', path: '/investor-relations' },
    { name: 'Digital Assets', path: '/digital-assets' },
    { name: 'Careers', path: '/careers' },
    { name: 'Contact', path: '/contact' },
  ];

  const showTransparent = isHome && !isScrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        showTransparent ? 'bg-transparent' : 'bg-white shadow-md'
      }`}
    >
      <div className="w-full px-6 lg:px-10">
        <div className="flex items-center justify-between h-24">
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <div className="w-48 h-20 flex items-center justify-center">
              <img
                src="https://public.readdy.ai/ai/img_res/d1778700-06dd-495c-ba1b-481a7ad371be.png"
                alt="Drixem Ventures by Drixem Group Logo"
                title="Drixem Ventures"
                className="w-48 h-20 object-contain"
              />
            </div>
          </Link>

          {/* Desktop navigation links */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? showTransparent
                      ? 'bg-white/20 text-white backdrop-blur-sm'
                      : 'bg-primary-600 text-white'
                    : showTransparent
                    ? 'text-white hover:bg-white/10'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Desktop WhatsApp button */}
          <div className="hidden lg:flex items-center">
            <a
              href="https://wa.me/60122353795"
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                showTransparent
                  ? 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
                  : 'bg-primary-600 text-white hover:bg-primary-700'
              }`}
            >
              <i className="ri-whatsapp-line text-lg"></i>
              <span>WhatsApp Us</span>
            </a>
          </div>

          {/* Mobile menu toggle */}
          <button
            onClick={() => setIsMobileMenuOpen((prev) => !prev)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              showTransparent
                ? 'text-white hover:bg-white/10'
                : 'text-gray-900 hover:bg-gray-100'
            }`}
            aria-label="Toggle menu"
          >
            <i
              className={`text-2xl ${
                isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
              }`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-6 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-primary-600 text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://wa.me/60122353795"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 px-4 py-3 rounded-lg text-sm font-semibold bg-primary-600 text-white cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              <span>WhatsApp: +6012-2353795</span>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
